<template>
  <span
    class="skip-link link-underline--primary"
    role="button"
    tabindex="0"
    @click="handleClick"
    @keydown.enter="handleClick"
    @keydown.space="handleClick"
  >
    {{ label }} <span class="material-icons-outlined">chevron_right</span>
  </span>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
}>();

const emit = defineEmits<{
  click: [];
}>();

const handleClick = () => {
  emit('click');
};
</script>

<style lang="scss" scoped>
@import '~green/_variables.scss';

.skip-link {
  // 既存 .link-underline--primary を併用。追加のカスタマイズのみ記述
  color: $primary-color;
  text-decoration: none;
  display: inline-flex;
  padding: 8px 0;
  font-size: 0.875rem;
  cursor: pointer;
  user-select: none;
  transition: opacity 0.2s ease;

  &:hover,
  &:focus {
    opacity: 0.8;
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid $primary-color;
    outline-offset: 2px;
    border-radius: 4px;
  }
}
</style>
